<template>
    <Modal title="黑名单" width="800" v-model="blackUserListShow" class="custom-modal">
      <Row :gutter="24">
        <pagination-table
          class="custom-table"
          :columns="blackUserTable.columns"
          :data="blackUserTable.data"
          :loading="blackUserTable.loading"
          :table-search="blackUserTable.tableSearch"
          :table-load-event="getBlackUserList"
          :autoHeight="true"
          :showPage="false"
        />
      </Row>
    </Modal>
</template>

<script>
import search from "@/libs/search";
import PaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { getSeedFarmBlackUserList, getSeedFarmBlackUserWithoutRoleList } from '@/api/modules/seedFarm-management/seedFarm-member-back';
import { dateTimeRender } from "@/libs/tableRowTimeRender";
export default {
    name: "BlackUserListModal",
    components: {
        PaginationTable
    },
    data() {
        return {
            blackUserListShow: false,
            role: true,
            blackUserTable:{
                columns: [
                    {
                        title: "苗场号",
                        key: "seedFarmCode",
                        align: "center"
                    },
                    {
                        title: "苗场",
                        key: "seedFarmName",
                        align: "center"

                    },
                    {
                        title: "会员号",
                        key: "userName",
                        align: "center"
                    },
                    {
                        title: "黑名单用户",
                        key: "userPersonName",
                        align: "center"
                    },
                    {
                        title: "修改人",
                        key: "modifierName",
                        align: "center"
                    },
                    {
                        title: "设置时间",
                        key: "modifyTime",
                        align: "center",
                        render: (h, params) => dateTimeRender(h, params.row.modifyTime)
                    }
                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    
    methods: {
        showModal(userId, role) {
            this.role = role;
            this.blackUserListShow = true;
            this.getBlackUserList(userId);
        },
        getBlackUserList(userId){
            this.blackUserTable.loading = true;
            search.globalAddFilterConditionKey(this.blackUserTable.tableSearch, "seedFarmBlackUser.userUuid", "eq", userId, true);
            if(this.role){
                console.log("1");
                getSeedFarmBlackUserList(this.blackUserTable.tableSearch).then(res => {
                    if (res.code === 0) {
                        this.blackUserTable.data = res.data.records;
                        search.globalSetFilterRecordCount(this.blackUserTable.tableSearch, res.data.filterRecordCount);
                    }
                    this.blackUserTable.loading = false;
                }).catch(() => {
                    this.blackUserTable.loading = false;
                });
            }
            else{
                console.log("2");
                getSeedFarmBlackUserWithoutRoleList(this.blackUserTable.tableSearch).then(res => {
                    if (res.code === 0) {
                        this.blackUserTable.data = res.data.records;
                        search.globalSetFilterRecordCount(this.blackUserTable.tableSearch, res.data.filterRecordCount);
                    }
                    this.blackUserTable.loading = false;
                }).catch(() => {
                    this.blackUserTable.loading = false;
                });
            }
            
        }
    }
};
</script>

<style scoped>
.custom-modal {
  border: 1px solid #ddd;
  box-shadow: 0 0 10px #ddd;
  border-radius: 5px;
}

.custom-modal .modal-header {
  background-color: #f0f0f0;
  font-weight: bold;
}

.custom-modal .modal-body {
  padding: 20px;
}

.custom-table::v-deep table {
  width: 100%;
}

.custom-table::v-deep th {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.custom-table::v-deep td, .custom-table::v-deep th {
  padding: 8px;
  vertical-align: middle;
}

.custom-table::v-deep tr {
  &:hover {
    background-color: #f5f5f5;
  }
}

.custom-table::v-deep tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>